import { Component } from '@angular/core';
import { FieldType } from '@ngx-formly/core';

@Component({
  standalone: false,
  selector: 'app-formly-field-tab',
  templateUrl: './formly-field-tab.component.html',
  styleUrls: ['./formly-field-tab.component.scss']
})
export class FormlyFieldTabComponent extends FieldType
{

}
